const ZIP_CODES_BASE = process.env.REACT_APP_API_ZIP_CODES || ""
const ZIP_CODES_KEY = process.env.REACT_APP_API_ZIP_CODES_DEAN || ""

export const isZipCodeApiConfigured = () =>
  Boolean(ZIP_CODES_BASE && ZIP_CODES_KEY)

export const getZipCodeApiConfigError = () =>
  "Zip code API is not configured. Add REACT_APP_API_ZIP_CODES and REACT_APP_API_ZIP_CODES_DEAN to dealeromg/.env (copy the key from Azure App Service production-domg-front → Configuration)."

export const buildZipRadiusUrl = (zipCode, radius) => {
  if (!isZipCodeApiConfigured()) {
    throw new Error(getZipCodeApiConfigError())
  }

  const base = ZIP_CODES_BASE.endsWith("/")
    ? ZIP_CODES_BASE
    : `${ZIP_CODES_BASE}/`

  return `${base}${ZIP_CODES_KEY}/radius.json/${zipCode}/${radius}/mile`
}
